<template>
	<div class="modal-mask bg-documentGray">
		<header class="mdc-top-app-bar">
			<div class="mdc-top-app-bar__row">
				<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
					<a href="javascript:void(0)" class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
						aria-label="Open navigation menu"  @click="goBackPreviousPage()" @keypress="goBackPreviousPage()" tabindex="0">close</a>
				</section>
				<section class="mdc-top-app-bar__section title d-flex justify-content-center">
					<div class="mdc-top-app-bar__title pdl-1"></div>
				</section>
				<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
					<!-- <div class="t-body2 t-color-white font-r pdr-16">등록</div> -->
				</section>
			</div>
		</header>
		<div class="mgt-100">
			<StreamBarcodeReader 
					@decode="(a, b, c) => onDecode(a, b, c)"
					@loaded="() => onLoaded()"
			></StreamBarcodeReader>
			<span>Input Value: {{ text || "Nothing" }}</span>
		</div>
	</div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
	 components: {
		StreamBarcodeReader
	},
	data() {
		return {
			text:'',
			productName:''
		}
	},
	methods:{
		onDecode(a, b, c) {	
			this.text = a;
			
				this.productName = this.text
				//this.productSearch()
				if(this.productName){
					localStorage.setItem('productName',this.productName)
					localStorage.setItem('setTab','tab2')
					this.goBackPreviousPage()
				}
			
			if (this.id) clearTimeout(this.id);
			this.id = setTimeout(() => {
				if (this.text === a) {
				this.text = "";
				}
			}, 5000);
		},

		onLoaded() {
			
		},

		goBackPreviousPage(){
			localStorage.setItem('setTab','tab2')
			this.$router.go(-1)
		}
	}
}
</script>